<template>
  <div
    class="wrapper"
    :class="['button-' + type, 'button-' + size]"
    @click="btnClick">
    <p
      class="button-text"
      :class="textClass">
      {{ text }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'small'
    },
    text: {
      type: String,
      default: ''
    },
    textClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    btnClick () {
      this.$emit('btnClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 44px;
  padding: 0 15px;
  border: none;
  border-radius: 4px;
  p.button-text {
    max-width: 100%;
    overflow: hidden;
    color: $color-bg-white;
    font-size: $base-font-size;
    line-height: 16px;
    white-space: nowrap;
    text-align: center;
    text-overflow: ellipsis;
    word-break: keep-all;
    @include font-Medium;
  }
  &:active {
    opacity: 0.3;
  }
}
.button-default {
  border: 1px solid $color-primary;
  p.button-text {
    color: $color-primary;
  }
}
.button-primary {
  background: $color-primary;
}
.button-small {
  width: 166px;
}
.button-big {
  width: 315px;
}
</style>
